import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'


import CookieConsentVue from './CookieConsentVue.js'


createApp(App)
  .use(store)
  .use(router)
  .use(CookieConsentVue, {
    revision: 1, //! change this to force users to re-consent when you change the consent modal.
    guiOptions: {
      consentModal: {
        layout: "box",
        position: "bottom center",
        equalWeightButtons: true,
        flipButtons: false
      },
      preferencesModal: {
        layout: "box",
        position: "right",
        equalWeightButtons: true,
        flipButtons: false
      }
    },
    categories: {
      necessary: {
        readOnly: true
      },
      analytics: {}
    },
    language: {
      default: "en",
      autoDetect: "browser",
      translations: {
        en: {
          consentModal: {
            title: "Hello, it's cookie time!",
            description: "This website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only after consent.",
            acceptAllBtn: "Accept all",
            acceptNecessaryBtn: "Reject all",
            showPreferencesBtn: "Manage preferences",
            footer: "<a href=\"/privacy\">Privacy Policy</a>\n "
          },
          preferencesModal: {
            title: "Consent Preferences Center",
            acceptAllBtn: "Accept all",
            acceptNecessaryBtn: "Reject all",
            savePreferencesBtn: "Save preferences",
            closeIconLabel: "Close modal",
            serviceCounterLabel: "Service|Services",
            sections: [
              {
                title: "Cookie Usage",
                description: "Hi, this website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only after consent."
              },
              {
                  title: "Strictly Necessary Cookies <span class=\"pm__badge\">Always Enabled</span>",
                  description: "Strictly Necessary Cookies are essential cookies that enable core functionality of a website, such as security, network management, and accessibility. These cookies are required for a website to operate properly and cannot be switched off in the system. They are typically used to ensure that basic features like page navigation, access to secure areas, and user authentication work as intended.",
                  linkedCategory: "necessary"
              },
              {
                  title: "Analytics Cookies",
                  description: "Analytic cookies are used to collect information about how users interact with a website, helping site owners understand and improve its performance. These cookies gather data on metrics such as page views, time spent on pages, navigation patterns, and the number of visitors. They enable the analysis of user behavior, often in an aggregated and anonymous form, to identify trends, optimize content, and enhance user experience. Common tools like Google Analytics rely on analytic cookies to track this data.",
                  linkedCategory: "analytics"
              },
              {
                  title: "More information",
                  description: "For any query in relation to my policy on cookies and your choices, go to <a class=\"cc__link\" href=\"/privacy\">Privacy Policy</a>."
              }
            ]
          }
        }
      }
    }
  })
  .mount('#app')
